export const DELTA_SCROLL_END = 10